import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('meeting_point_code'),
	fieldsMap.get('meeting_point_description'),
	fieldsMap.get('time'),
	fieldsMap.get('note')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
